// careerPage/careerPage.tsx
import React, { FunctionComponent } from 'react';
import { useLocale } from '../../contexts/LocaleProvider';
import { IntlProvider } from 'react-intl';
import { Box } from '@mui/material';
import ReusableTabs from '../common/ReusableTabs';
import * as styles from '../productPage/tableComponents/ProductPage_style';
import BreadCrumbs from '../common/BreadCrumbs';
import InnovatePage from './InnovatePage';

import { useAboutCareersContent } from '../../graphql/pimcore/modules/siteContent/hooks/useAboutCareersContent';
import DebouncedLoader from '../common/DebouncedLoader';

const CareerPage: FunctionComponent = () => {
    const { loading, error, contentTree } = useAboutCareersContent();

    const { locale, messages } = useLocale();

    return (
        <DebouncedLoader loading={loading} delay={1000} size={40} centered>
            <IntlProvider locale={locale} key={locale} defaultLocale="en" messages={messages}>
                <Box
                    width="100%"
                    component="main"
                    sx={{
                        padding: 0,
                        flexGrow: 0,
                        p: 0,
                    }}
                >
                    <ReusableTabs
                        bannerImage={contentTree.pageTitleBackgroundImage.imageUrl}
                        bannerTitle={contentTree.pageTitle.content}
                        bannerDescription={contentTree.pageSubtitle.content}
                        tabLabels={[contentTree.mainTab.title.content]}
                        tabKeys={['Innovate with Us']}
                        tabContents={[
                            <InnovatePage key="innovate" cmsContent={contentTree.mainTab} />,
                        ]}
                        bannerFontStyle={styles.bannerFont}
                        subBannerFontStyle={styles.bannerFont2}
                        pageName={contentTree.pageTitle.content}
                        showTabs={true}
                        breadcrumbs={<BreadCrumbs navigationPath="/Home/About/Careers" />}
                    />
                </Box>
            </IntlProvider>
        </DebouncedLoader>
    );
};

export default CareerPage;
